import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Button, Form, Input, Modal, App } from "antd";
import { login } from "../../redux/slice/userslice";
import { POST } from "../../utils/apicalls";
import Logo from "../../assets/logo-PNG.png";

import { API } from "../../config/api";
import "./login.css";

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { notification } = App.useApp();
  const [loading, setLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [form] = Form.useForm();

  const onFinish = async (values: any) => {
    try {
      setLoading(true);
      const obj = {
        adminUsername: values.adminUsername,
        adminpassword: values.adminpassword,
        type: "admin",
      };

      const { data, status, message }: any = await POST(API.ADMIN_LOGIN, obj);

      if (status) {
        notification.success({ message });
        dispatch(login(data));
        localStorage.setItem("user", JSON.stringify(data));
        navigate("/admin/adminDashboard");
      } else {
        notification.error({ message });
      }
    } catch (error) {
      console.error("Login failed:", error);
      notification.error({ message: "Login failed. Please try again." });
    } finally {
      setLoading(false);
    }
  };

  const handleUpdatePassword = async () => {
    try {
      const values = await form.validateFields();
      let { adminUsername, currentPassword, newPassword } = values;

      const { status, message }: any = await POST(API.PASSWORD_UPDATE_ADMIN, {
        adminUsername,
        currentPassword,
        newPassword
      });

      if (status) {
        notification.success({ message: "Password updated successfully." });
      } else {
        notification.error({ message });
      }
    } catch (error) {
      console.error("Password update failed:", error);
      notification.error({ message: "Failed to update password. Try again." });
    } finally {
      setIsModalVisible(false);
    }
  };

  return (
    <div className="loginScreen">
      <div className="backgroundOverlay"></div>

      <div className="loginContainer">
        <img src={Logo} alt="logo" className="loginLogo" />
        <div className="loginScreen-txt1">Login and Continue</div>

        <Form onFinish={onFinish} layout="vertical">

          <Form.Item
            label="Username"
            name="adminUsername"
            rules={[{ required: true, message: "Required" }]}
          >
            {/* <h3>User name</h3> */}
            <Input placeholder="Enter your username" size="large" />
          </Form.Item>

          <Form.Item
            label="Password"
            name="adminpassword"
            rules={[{ required: true, message: "Required" }]}
          >
            <Input.Password placeholder="Enter your password" size="large" />
          </Form.Item>

          <div className="forgotPassword">
            <span onClick={() => setIsModalVisible(true)}>
              Forgot Password?
            </span>
          </div>

          <Button
            block
            size="large"
            htmlType="submit"
            type="primary"
            loading={loading}
          >
            Sign In
          </Button>
        </Form>
      </div>

      {/* Forgot Password Modal */}
      <Modal
        title="Update Password"
        open={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        onOk={handleUpdatePassword}
        okText="Update Password"
      >
        <Form form={form} layout="vertical">
          <Form.Item
            label="Enter your Username"
            name="adminUsername"
            rules={[{ required: true, message: "Please enter your Username" }]}
          >
            <Input placeholder="Enter your username" />
          </Form.Item>

          <Form.Item
            label="Old Password"
            name="currentPassword"
            rules={[
              { required: true, message: "Please enter your old password" },
              { min: 6, message: "Password must be at least 6 characters" },
            ]}
          >
            <Input.Password placeholder="Enter old password" />
          </Form.Item>
          <Form.Item
            label="NewPassword"
            name="newPassword"
            rules={[
              { required: true, message: "Please enter your new password" },
              { min: 6, message: "Password must be at least 6 characters" },
            ]}
          >
            <Input.Password placeholder="Enter new password" />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default Login;
